import React from 'react'

import {
  Divider,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react'
import floatingPointFix from 'js-floating-point'
import { isNumber } from 'lodash'
import useTranslation from 'next-translate/useTranslation'

import { SubmitModalFooter } from 'components/SubmitModalFooter'
import { useRegion } from 'providers/RegionProvider'
import { getLocaleFormattedPrice } from 'utils/price'

type Props = {
  isOpen: boolean
  onClose: () => void
  pricePerMonth?: number
  successFee?: number
  isSubmitLoading?: boolean
  onSubmit: () => void
}

export const EnterpriseSubmitModal = ({
  isOpen,
  onClose,
  pricePerMonth,
  successFee,
  isSubmitLoading,
  onSubmit,
}: Props) => {
  const { t } = useTranslation('common')
  const { region } = useRegion()

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent w="full" maxW="520px">
        <ModalHeader>{t('TRANSLATION_369')}</ModalHeader>
        <ModalCloseButton />
        <Divider mb="2" />
        <ModalBody>
          <Flex direction="column">
            <Text fontSize="16px">{t('TRANSLATION_370')}</Text>
            <Flex>
              <Text fontSize="16px">{t('TRANSLATION_371')}</Text>
              {pricePerMonth && (
                <Text pl="8px" fontSize="16px" fontWeight="600">
                  {getLocaleFormattedPrice({ price: pricePerMonth, region })}
                </Text>
              )}
              <Text fontSize="16px">{t('TRANSLATION_372')}</Text>
            </Flex>
            <Flex>
              <Text fontSize="16px">{t('TRANSLATION_373')}</Text>
              {isNumber(successFee) && (
                <Text pl="8px" fontSize="16px" fontWeight="600">
                  {floatingPointFix(successFee * 100)}%
                </Text>
              )}
            </Flex>
          </Flex>
        </ModalBody>
        <SubmitModalFooter
          submitButtonText="Confirm & Pay"
          onCancel={onClose}
          isSubmitLoading={isSubmitLoading}
          onSubmit={onSubmit}
        />
      </ModalContent>
    </Modal>
  )
}
